/* eslint-disable no-console */
import { getRunningEnv } from './env-helper'

const debug = (message = '', data = '') => {
	if (getRunningEnv() !== "PRD") {
		const isApiMessage = message.indexOf('[API]') >= 0
		let color = "#969696"
		if (isApiMessage) {
			color = "#006600"
		}
		console.log(`%c${message}`, `color: ${color}`, data)
	}
}

const error = (message = '') => {
	if (getRunningEnv() !== "PRD") {
		console.error(`%c${message}`, `color: #CC3300`)
	}
}

export default {
	debug,
	error
}